<template>
    <div>

        <h3 v-if="componentType == 'duplicate'">
            <translate>Duplicate trip:</translate>&nbsp;
            {{number}}
        </h3>
        <h3 v-if="componentType == 'return'">
            <translate>Return trip:</translate>&nbsp;
            {{number}}
        </h3>

        <div class="grid-container component-block">
            <div class="info-cell">
                <div class="info-cell-label">From</div>
                <div>{{from}}</div>
            </div>
            <div class="info-cell">
                <div class="info-cell-label">To</div>
                <div>{{to}}</div>
            </div>
            <div class="info-cell">
                <div class="info-cell-label">Distance</div>
                <div>{{tripDetails.total_distance}}</div>
            </div>
        </div>

        <div class="component-block">
            
            <b-form ref="copytripform" @submit.prevent="saveForm">

                <div v-if="tripDetails.car">
                    <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                        <template slot="label">
                            <span v-translate>Odometer (end)*</span>
                        </template>
                        <b-input-group>
                            <template #append>
                                <b-input-group-text>km</b-input-group-text>
                            </template>
                            <b-form-input id="input-1" type="number" v-model="end_odometer" min="0" :required="true"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>

                <div>
                    <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" label-for="input-2">
                        <template slot="label">
                            <span v-translate>Date*</span>
                        </template>
                        <b-input-group>
                            <b-form-datepicker id="input-2a" v-model="dateDetail" class="mr-2" :required="true" :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" @input="onDateChanged"></b-form-datepicker>
                            <b-form-timepicker id="input-2b" v-model="timeDetail" class="ml-2" :required="true" @input="onDateChanged"></b-form-timepicker>
                        </b-input-group>
                    </b-form-group>
                </div>

            </b-form>
        </div>

        <div v-if="showWarning" class="component-block warning">
            <span v-translate>
                There is a trip at a later date. If you save this item your odometer might overlap with the odometer from the later trip. If this happens your registration will be incorrect.
            </span>
        </div>

    </div>    
</template>

<script>
import CarsService from "@/store/services/cars.service";
import TripService from "@/store/services/trip.service";

export default {
    name: "CopyTrip",
    props: {
        componentType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            tripDetails: {
                number: "",
                start: {},
                end: {},
                company_profile: window.company_id,
                customer: null,
                project: null,
                car: null,
                created_by: window.user_id,
                transport_type: "car",  // default
                type: "business",  // default
                description: "",
                private_distance: 0,
                total_distance: 0,
                end_odometer: 0,
                date: null,
                total_hours: "0.00",
                is_invoiced: false,
                invoice: null,
                route: null,
                raw_route: "",
                created: null,
                modified: null
            },
            number: null,
            dateDetail: null,
            timeDetail: null,
            from: null,
            to: null,
            end_odometer: null,
            showWarning: false,
            lastTripDate: null
        }
    },
    created() {
        let vm = this;
        this.tripDetails = this.$store.getters['tripStore/getTripDetails'];

        if (this.componentType === "return") {
            let end = this.tripDetails.end;
            this.tripDetails.end = this.tripDetails.start;
            this.tripDetails.start = end;
        }
        
        if (this.tripDetails && this.tripDetails.start)
            this.from = this.tripDetails.start.name;
        if (this.tripDetails && this.tripDetails.end)
            this.to = this.tripDetails.end.name;

        if (this.tripDetails.car) {
            CarsService.retrieve(this.tripDetails.car).then(function(response) {
                vm.end_odometer = parseFloat(response.data.odometer) + parseFloat(vm.tripDetails.total_distance);
            });
        }

        TripService.getLast().then(function(response) {
            let dateObj = Date.parse(response.data.date);
            vm.lastTripDate = dateObj;
            let month = dateObj.getMonth() + 1; // getMonth would return a value between 0 and 11
            vm.dateDetail = dateObj.getFullYear() + "-" + month + "-" + dateObj.getDate();
            vm.timeDetail = dateObj.getHours() + ":" + dateObj.getMinutes() + ":" + dateObj.getSeconds();

            let data = {"year": dateObj.getFullYear()};
            TripService.getNextTripNumber(window.company_id, data).then(function(response) {
                vm.number = response.data;
            });
        });
    },
    methods: {
        saveForm() {
            let vm = this;

            this.tripDetails.end_odometer = this.end_odometer;
            if (this.dateDetail && this.timeDetail)
                this.tripDetails.date = this.dateDetail.toString() + ' ' + this.timeDetail.toString();
            this.tripDetails.number = this.number;

            TripService.create(this.tripDetails).then(function(response) {
                vm.$emit("created", response.data);
                vm.$router.push({name: "Trips"});
                vm.$store.commit('setAlert', {
                    title: vm.$gettext("Trip added"),
                    text: vm.$gettext("The trip was added to the list."),
                    duration: 4
                });
            }).catch(function(response) {
                let msg = vm.$gettext('The trip could not be added to the list.');
                if (response.response) {
                    if (response.response.data) {
                        let firstDictKey = Object.keys(response.response.data)[0];
                        if (firstDictKey === "non_field_errors")
                            msg = vm.$gettext("The trip number has already been registered.");
                        else
                            msg = response.response.data[firstDictKey][0];
                    }
                }
                vm.$store.commit('setAlert', {
                    title: vm.$gettext("Error adding trip"),
                    text: msg,
                    variant: "error",
                    duration: 4
                });
            });
        },
        onDateChanged() {
            let dateObject = new Date(this.dateDetail.toString() + ' ' + this.timeDetail.toString());

            if (this.lastTripDate > dateObject)
                this.showWarning = true;
            else
                this.showWarning = false;
            
        }
    }
}
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: auto auto;
}

.info-cell {
    margin: 10px;
}

.info-cell-label {
    font-family: DINNextLTPro-Medium, sans-serif;
}

.component-block {
    padding-top: 10px;
    padding-bottom: 10px;
}

.warning {
    background-color: #fcf8e3;
    border: 1px solid #faebcc;
    color: #8a6d3b;
    padding: 10px;
}
</style>